import React from 'react';

const Logo: React.FC = () => {
    return (
        <span style={{ fontFamily: 'Source Code Pro, monospace', color: "#f3f3f7" }}>
            mol
            <span style={{ color: '#47d0ae' }}>
                IE
            </span>
            re
            <span style={{ color: '#fdb812' }}>
                VIS
            </span>
        </span>
    );
}

export default Logo;
